import { ref } from 'vue';
import { apiLink } from './apiLink'
//import { getToken } from './msal/fetch';
import { Auth } from '@/services/authService';

const host = ref (apiLink + '/')
const credtype = 'same-origin' //'include'
//gets the data from the api, also called load in other files
const currentHost = window.location.hostname;

// 🚀 The background beacon that hits your new anonymous C# endpoint
const shipTelemetry = (hostt, message) => {
    let endPoint = 'useradmin/log-telemetry'
    let url = `${host.value}${endPoint}`
    console.log('shipTelem', url)
    fetch(url, {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json; charset=UTF-8' 
            // Note: NO Authorization header here! It intentionally passes anonymously.
        },
        body: JSON.stringify({
            clientHost: hostt,
            errorMessage: message
        })
    })
    .then(res => {
        if (!res.ok) {
            console.warn(`Telemetry dropped by server with status: ${res.status}`);
        } else {
            console.warn(`Telemetry accepted by server with status: ${res.status}`);
        }
    })
    .catch(e => console.error("Telemetry failed to ship entirely:", e));
}

const getData = (endPoint, type, my404answer) => {
    let url = `${host.value}${endPoint}`

    console.log('fetch from:', '-',url,'-')

    return Auth.getToken()
        .then((result) =>{ 
            if (!result) {
                const errorMsg = "MSAL token resolved to null. Missing context or interaction required.";
                
                // Ship diagnostics to your text file without blocking the UI
                throw Error(errorMsg);
                return null;
            }
            if (result==null) {
                console.log('token is null for ' + type)
                return null //don't let more garbage spit to the console - no token - don't proceed
            }
            return fetch(url,
                {
                    headers: {
                        'content-type': 'application/json; charset=UTF-8',
                        'Authorization': 'Bearer ' + result
                    },
                })
        })
        .catch (err => {
            let msg = `ERROR: getToken ${type} ${err}`
            console.log(msg)
            throw Error (msg)
        })
        .then(response => {
            
            console.log(`GET response: `, response)
            if (response.ok && response.status===204){
                 
                    return my404answer;
                
            } else if (!response.ok) {



                //return the 404 answer given if status is 404
                if (response.status == 404) {
                    console.log("returning my404answer", my404answer)
                    return my404answer;
                }
                return response.text().then(rawText => {
                    // 1. Log EXACTLY what the C# backend sent (empty string, HTML, raw text, or JSON)
                    console.log(`Backend Raw Response [Status ${response.status}]:`, rawText || "[Empty Body]");

                    let parsedBody;
                    try {
                        // 2. See if it's valid JSON
                        parsedBody = JSON.parse(rawText);
                    } catch (e) {
                        // 3. If it's not JSON, just keep the raw text for your error message
                        parsedBody = rawText; 
                    }

                    let msg = `ERROR: server returned status ${response.status} (${response.statusText}) for ${type}. Body: ` + JSON.stringify(parsedBody);
                    console.log("Not 404 error: " + msg);
                    throw Error(msg);
                });
                // return response.json()
                //     .then(r => { //throw an error if the status is not 404
                //         let msg = `ERROR: unknown response type for ${type} ${response.status.toString()} (${response.statusText}) response from server: ` + JSON.stringify(r)    
                //         console.log("Not 404 error: " + msg)
                //         throw Error(msg)
                               
                //     }).catch (async err => {

                //         let rawText = "";
                //         try {
                //             rawText = await response.text();
                //         } catch {
                //             rawText = "[Could not read response body] " + response.status.toString();
                //         }

                //         let msg2 = `ERROR: response.json error for ${type} err: ` + JSON.stringify(err) + rawText
                //         console.log("Not 404 catch: " + msg2)
                //         throw Error (msg2)
                //     })
            } else {
                console.log('good answer get')
                return response.json()
            }
        })
        .catch (err => {
            let msg = `ERROR: fetching data for ${type} ${err}`
            console.log(msg)

            shipTelemetry(currentHost, msg);

            throw Error (msg)
        })
} 

const getBlob = (endPoint, type) => {
    let url = `${host.value}${endPoint}`

    console.log('fetch from:', '-', url, '-')

    return Auth.getToken()
        .then((result) => {
            if (result == null) {
                console.log('token is null for ' + type)
                return null
            }
            return fetch(url, {
                headers: {
                    'Authorization': 'Bearer ' + result
                },
            })
        })
        .then(response => {
            if (!response.ok) {
                let msg = `ERROR: failed to fetch PDF for ${type} ${response.status.toString()} (${response.statusText})`
                console.log(msg)
                throw Error(msg)
            }
            console.log('good answer get - parsing as PDF')
            return response.blob()
        })
        .catch(err => {
            let msg = `ERROR: fetching PDF data for ${type} ${err}`
            console.log(msg)
            throw Error(msg)
        })
}

const putData = (endPoint, data, type, my404answer) => {
    let url = `${host.value}${endPoint}`

    return Auth.getToken()
        .then((result) =>{ 
            if (result==null) {
                console.log('token is null for ' + type)
                return null //don't let more garbage spit to the console - no token - don't proceed
            }
            return fetch (url, 
                {
                    method: 'PUT',
                    body: JSON.stringify(data),
                    headers: {
                        'content-type': 'application/json; charset=UTF-8',
                        'Authorization': 'Bearer ' + result
                    },
                })
        })
        .then(response => {
            //console.log(`PUT Response: `, response)

            if (!response.ok) {
                //return the 404 answer given if status is 404
                if (response.status == 404) {
                    console.log("returning my404answer", my404answer)
                    return my404answer;
                }
                //console.log('getting json answer')
                return response.json()
                    .then(r => { //throw an error if the status is not 404
                        let msg = `ERROR: unknown response type for ${type} ${response.status.toString()} (${response.statusText}) response from server: ` + JSON.stringify(r)    
                        console.log("Not 404 error: ", msg)
                        throw Error(msg)
                    }).catch (err => {
                        let msg2 = `ERROR: response.json error for ${type} err: ` + JSON.stringify(err)
                        console.log("Not 404 catch: ", msg2)
                        throw Error (msg2)
                    })
            } else { //return the response if the status is ok
                console.log('good answer put')
                return response.json()
            }
        })
        .catch (err => {
            let msg = `ERROR: fetching data for ${type} ${err}`
            console.log(msg)
            throw Error (msg)
        })
}

// Used for an edge case to maintain legacy code where the status of the result is important information we need to have
const putDataRaw = (endPoint, data, type, my404answer) => {
    let url = `${host.value}${endPoint}`

    return Auth.getToken()
        .then((result) =>{ 
            if (result==null) {
                console.log('token is null for ' + type)
                return null //don't let more garbage spit to the console - no token - don't proceed
            }
	      return fetch (url, 
	        {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'content-type': 'application/json; charset=UTF-8',
                'Authorization': 'Bearer ' + result
	            },
	        })
        })
        .then(response => {
            //console.log(`PUT Response: `, response)

            if (!response.ok) {
                //return the 404 answer given if status is 404
                if (response.status == 404) {
                    console.log("returning my404answer", my404answer)
                    return my404answer;
                }
                //console.log('getting json answer')
                response.json()
                    .then(r => { //throw an error if the status is not 404
                        let msg = `ERROR: unknown response type for ${type} ${response.status.toString()} (${response.statusText}) response from server: ` + JSON.stringify(r)    
                        console.log("Not 404 error: ", msg)
                        throw Error(msg)
                    }).catch (err => {
                        let msg2 = `ERROR: response.json error for ${type} err: ` + JSON.stringify(err)
                        console.log("Not 404 catch: ", msg2)
                        throw Error (msg2)
                    })
            } else { //return the response if the status is ok
                console.log('good answer put')
                return response
            }
        })
        .catch (err => {
            let msg = `ERROR: fetching data for ${type} ${err}`
            console.log(msg)
            throw Error (msg)
        })
}
const getVideo = (endPoint, data, type, my404answer) => {
    let url = `${host.value}${endPoint}`

    return Auth.getToken()
        .then((result) =>{ 
            if (result==null) {
                console.log('token is null for ' + type)
                return null //don't let more garbage spit to the console - no token - don't proceed
            }
	      return fetch (url, 
	        {
            method: 'GET',
           
            headers: {
                
                'Authorization': 'Bearer ' + result
	            },
	        })
        })
        .then(response => {
            //console.log(`PUT Response: `, response)

            if (!response.ok) {
                //return the 404 answer given if status is 404
                if (response.status == 404) {
                    console.log("returning my404answer", my404answer)
                    throw Error(`Server returned ${response.status}: ${response.statusText}`);
                }
                console.log('getting blob answer')
                return response.blob();
                
            } else { //return the response if the status is ok
                console.log('good answer put')
                return response
            }
        })
        .catch (err => {
            let msg = `ERROR: fetching data for ${type} ${err}`
            console.log(msg)
            throw Error (msg)
        })
}

const postData = (endPoint, data, type, my404answer, isBlob=false, isXml=false) => {
    let url = `${host.value}${endPoint}`

    return Auth.getToken()
        .then((result) =>{
            if (result==null) {
                console.log('token is null for ' + type)
                return null //don't let more garbage spit to the console - no token - don't proceed
            } 
            if (!isXml) {
                return fetch (url, 
                    {
                        method: 'POST',
                        body: JSON.stringify(data),
                        headers: {
                            'content-type': 'application/json; charset=UTF-8',
                            'Authorization': 'Bearer ' + result
                        },
                    })
            } else {
                console.log(data, "@@@@")
                return fetch (url, 
                    {
                        method: 'POST',
                        body: data,
                        headers: {
                            'Authorization': 'Bearer ' + result
                        },
                    })
            }
        })
        .then(response => {
            console.log(`POST response: `, response)

            if (!response.ok) {
                //return the 404 answer given if status is 404
                if (response.status == 404) {
                    console.log("returning my404answer", my404answer)
                    return my404answer;
                } else if (response.status==4000){
                    console.log("ERROR: returning 400", response)
                    throw Error ("ERROR 400: " + json.stringify(response))
                }
                
                return response.json()
                    .then(r => { //throw an error if the status is not 404
                        let msg ='';
                        try {
                            console.log(1)
                            msg = `ERROR: unknown response type for ${type} ${response.status.toString()} (${response.statusText}) response from server: ` + JSON.stringify(r)    
                        } catch {
                            try {
                                console.log(2)
                                msg=`ERROR: unknown response type response from server: ` + JSON.stringify(r)    
                            } catch {
                                console.log(3)
                                    msg=`ERROR: unknown response type response from server: ` + r    
                            }
                            
                        }
                        console.log("Not 404 error: " , msg)
                        throw Error(msg)                
                    }).catch (err => {
                        let msg2 = ''
                        try {
                            console.log('3',err, typeof(err))
                            //https://dev.to/zirkelc/stringify-and-parse-errors-in-javascript-2lnh
                            let serializedError = JSON.stringify(err, 
                                Object.getOwnPropertyNames(err)
                              );
                              
                            msg2 =  JSON.stringify(serializedError)
                            msg2 = err
                        } catch {
                            msg2 = err
                        }
                        throw Error (msg2)
                    })
            } else { //return the response if the status is ok
                console.log('good answer post')
                if (isBlob) {
                    return response.blob()
                }
                if (isXml) {
                    return response.text().then(text => {
                        const parser = new DOMParser()
                        return parser.parseFromString(text, 'application/xml')
                    })
                }
                return response.json()
            }
        })
        .catch (err => {
            let msg = `ERROR: fetching data for ${type} ${err}`
            console.log(msg)
            throw Error (msg)
        })
}


const deleteData = (endPoint, type, my404answer) => {
    console.log('generalio deleteData', type, my404answer)
    
    let url = `${host.value}${endPoint}`

    return Auth.getToken()
        .then((result) =>{ 
            if (result==null) {
                console.log('token is null for ' + type)
                return null //don't let more garbage spit to the console - no token - don't proceed
            }
            return fetch (url, {
                method: 'DELETE',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                    'Authorization': 'Bearer ' + result
                }
            })
        })
        .then(response => {
            //console.log(`DELETE response: `, response)

            if (!response.ok) {
                //return the 404 answer given if status is 404
                if (response.status == 404) {
                    console.log("returning my404answer", my404answer)
                    return my404answer;
                }
                
                return response.json()
                    .then(r => { //throw an error if the status is not 404
                        let msg = `ERROR: unknown response type for ${type} ${response.status.toString()} (${response.statusText}) response from server: ` + JSON.stringify(r)    
                        console.log("Not 404 error: " + msg)
                        throw Error(msg)                
                    }).catch (err => {
                        let msg2 = `ERROR: response.json error for ${type} err: ` + JSON.stringify(err)
                        console.log("Not 404 catch: " + msg2)
                        throw Error (msg2)
                    })
            } else { //return the response if the status is ok
                console.log('good answer delete')
                return response.json()
            }
        })
        .catch (err => {
            let msg = `ERROR: fetching data for ${type} ${err}`
            console.log(msg)
            throw Error (msg)
        })
}

const patchData = (endPoint, data, type, my404answer) => {
    let url = `${host.value}${endPoint}`

    return Auth.getToken()
        .then((result) =>{     
            if (result==null) {
                console.log('token is null for ' + type)
                return null //don't let more garbage spit to the console - no token - don't proceed
            }    
            return fetch(url, {
                method: 'PATCH',
                body: JSON.stringify(data),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                    'Authorization': 'Bearer ' + result
                },
            })
        })
        .then(response => {
            //console.log(`PATCH response:`, response)

            if (!response.ok) {
                //return the 404 answer given if status is 404
                if (response.status == 404) {
                    console.log("returning my404answer", my404answer)
                    return my404answer;
                }
                
                return response.json()
                    .then(r => { //throw an error if the status is not 404
                        let msg = `ERROR: unknown response type for ${type} ${response.status.toString()} (${response.statusText}) response from server: ` + JSON.stringify(r)    
                        console.log("Not 404 error: " + msg)
                        throw Error(msg)                
                    }).catch (err => {
                        let msg2 = `ERROR: response.json error for ${type} err: ` + JSON.stringify(err)
                        console.log("Not 404 catch: " + msg2)
                        throw Error (msg2)
                    })
            } else { //return the response if the status is ok
                console.log('good answer patch')
                return response.json()
            }
        })
        .catch (err => {
            let msg = `ERROR: fetching data for ${type} ${err}`
            console.log(msg)
            throw Error (msg)
        })
}

const patchDataRaw = (endPoint, data, type, my404answer) => {
    let url = `${host.value}${endPoint}`

  return Auth.getToken()
  .then((result) =>{   
    if (result==null) {
        console.log('token is null for ' + type)
        return null //don't let more garbage spit to the console - no token - don't proceed
    }      
    return fetch(url, {
        method: 'PATCH',
        body: JSON.stringify(data),
        headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'Authorization': 'Bearer ' + result
        },
            })
    })
    .then(response => {
        //console.log(`PATCH response:`, response)

        if (!response.ok) {
                //return the 404 answer given if status is 404
                if (response.status == 404) {
                    console.log("returning my404answer", my404answer)
                    return my404answer;
                }
                
                return response.json() //STEVEN does a re return belong here?????
                    .then(r => { //throw an error if the status is not 404
                        let msg = `ERROR: unknown response type for ${type} ${response.status.toString()} (${response.statusText}) response from server: ` + JSON.stringify(r)    
                        console.log("Not 404 error: " + msg)
                        throw Error(msg)                
                    }).catch (err => {
                        let msg2 = `ERROR: response.json error for ${type} err: ` + JSON.stringify(err)
                        console.log("Not 404 catch: " + msg2)
                        throw Error (msg2)
                    })
            } else { //return the response if the status is ok
                console.log('good answer patch')
                return response
            }
        })
        .catch (err => {
            let msg = `ERROR: fetching data for ${type} ${err}`
            console.log(msg)
            throw Error (msg)
        })
}


const getLocalStorageForProject = (key, projectId, defaultVal) => {
    let tempNum = defaultVal
    let tempArray = localStorage.getItem(key)
    
    if (tempArray != null) {
        let tv = JSON.parse(tempArray)
        //console.log('tv',tv )
        //console.log('tv[Number(projectId)] ',tv[Number(projectId)], Number(projectId) )
        if (tv!=null && tv[Number(projectId)] != undefined) {
            tempNum = tv[Number(projectId)]
        }
    }
    return tempNum
} 
const setLocalStorageForProject = (key, projectId, valuee) => {
    let tempArray = localStorage.getItem(key)

    if (!tempArray) { // Just set the item since none exists
        let tempItem = {}
        tempItem[Number(projectId)] = valuee
        //console.log('tempItem',tempItem )
        localStorage.setItem(key,JSON.stringify(tempItem))
    } else { // Use the existing item and add to it
        let tempItem = JSON.parse(tempArray)
        tempItem[Number(projectId)] = valuee
        localStorage.setItem(key, JSON.stringify(tempItem))
    }
} 

export { getVideo, getData, putData, postData, putDataRaw, deleteData, patchData, patchDataRaw, getLocalStorageForProject, setLocalStorageForProject, getBlob}